import { navigate } from 'gatsby';
import * as React from 'react';

import { Button as MuiButton, IButtonProps } from '@nelnet/unifi-components-react';

interface IExtendedButtonProps extends IButtonProps {
  to: string;
}

const Button: React.FunctionComponent<IExtendedButtonProps> = ({
  children,
  color,
  variant,
  to,
  ...props
}) => {
  const url = to;
  let internal = /^\/(?!\/)/.test(url);

  if (url.includes('angular.unifi')) {
    internal = true;
  }

  if (internal) {
    return (
      <MuiButton
        variant={variant || 'contained'}
        color={color || 'primary'}
        onClick={() => navigate(url)}
        component="a"
        role={undefined}
        href={url}
        {...props}
      >
        {children}
      </MuiButton>
    );
  }

  return (
    <MuiButton
      variant={variant || 'contained'}
      color={color || 'primary'}
      href={url}
      {...props}
      // target="_blank"
    >
      {children}
    </MuiButton>
  );
};

export default Button;
